var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5a574f3d5c399c1780a74e0f71d7234c6748d45f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["oscarswap@oscarswap-nd"]={id:"5a574f3d5c399c1780a74e0f71d7234c6748d45f"};
      